
export default "/assets/gift-micro.38cf334b.svg"